import URLSearchParams from '@ungap/url-search-params';

export const getURLParameters = (name: string): string | null => {
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(name);
  }
  return null;
};

// Only work on comma separated values
export const getUniqueValuesFromString = (value: string): string[] => [
  ...new Set(value.split(',')),
];
